// extracted by mini-css-extract-plugin
export default {"userBox":"User_userBox__lNWHN","backgroundGif":"User_backgroundGif__on9Pq","userImage":"User_userImage__hg2Lj","userDetails":"User_userDetails__jxa0A"};